import styled from 'styled-components';

import {breakpoint} from 'theme';

export const MaxWidthContainer = styled.div`
    padding: 0 15px;

    @media (min-width: ${breakpoint.desktop}) {
        margin-left: 180px;
        padding: 0 20px;
    }

    @media print {
        margin: 0;
    }
`;
